// extracted by mini-css-extract-plugin
export default {"form":"PasswordRecoveryForm_form__BtUHz","submitButton":"PasswordRecoveryForm_submitButton__3MQXC","centered":"PasswordRecoveryForm_centered__XVuph"};